import React from 'react';
import './CSS/PolicyPage.css';

const Privacy = () => {
  return (
    <div className="policy-page container">
      <h1>Privacy Policy</h1>
      
      <div className="policy-section">
        <h2>1. Information We Collect</h2>
        <p>We collect information that you provide directly to us, such as when you create an account, place an order, or contact us. This may include your name, phone number, delivery location (hostel), and order details.</p>
      </div>

      <div className="policy-section">
        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to provide, maintain, and improve our services. This includes processing your transactions, delivering your orders, and communicating with you about your orders. Your contact number is shared with the vendor for delivery purposes only.</p>
      </div>

      <div className="policy-section">
        <h2>3. Data Security</h2>
        <p>We are committed to ensuring that your information is secure. We use industry-standard security measures to protect your data from unauthorized access, disclosure, or alteration. However, no method of transmission over the Internet is 100% secure.</p>
      </div>
    </div>
  );
};

export default Privacy;